/* PŘEDVYPLNĚNÉ CÍLE ŠABLONY (c1–c4) A „NEDOTČENÝ ŠABLONOVÝ CÍL“
 * ============================================================================
 * Samostatný modul BEZ IMPORTŮ (13. 10. 2026, krok Cíle a dopočet renty,
 * rozhodnutí hlavní relace CX2-10). Data šablony dřív žila jen v `EMPTY.cile`
 * (model.js) a `jeSablonaCile` ve stavy.js, která model importuje. Fáze schůzky
 * (`stavFazi` v model.js) teď potřebuje vědět, jestli cíl plán dopočítá —
 * a k tomu patří i výjimka pro nedotčenou šablonu. Import stavy.js z model.js
 * by udělal kruh (stavy.js čte `EMPTY` už při načtení), proto data i test
 * šablony stojí tady a model.js, stavy.js i dopocetCile.js je berou odsud.
 *
 * `EMPTY.cile` v model.js je kopie těchto řádků — obsah se nezměnil ani o znak.
 */

/** Čtyři předvyplněné cíle čerstvé analýzy (pořadí, názvy a termíny šablony). */
export const CILE_SABLONY = Object.freeze([
  Object.freeze({ id: "c1", popis: "Povinná likvidní rezerva", roky: 0, typ: "Rezerva", hodnota: 0, mesicne: false }),
  Object.freeze({ id: "c2", popis: "Bydlení / rekonstrukce", roky: 5, typ: "Bydlení", hodnota: 0, mesicne: false }),
  Object.freeze({ id: "c3", popis: "Vzdělání pro děti / start do života", roky: 15, typ: "Budoucnost dětí", hodnota: 0, mesicne: false }),
  Object.freeze({ id: "c4", popis: "Finanční nezávislost", roky: 25, typ: "Finanční nezávislost", hodnota: 0, mesicne: true }),
]);

/** Nové (nezmrazené) kopie řádků šablony — pro `EMPTY.cile`. */
export function cileSablony() {
  return CILE_SABLONY.map((c) => ({ ...c }));
}

const norm = (s) => String(s ?? "").trim().toLowerCase();
const num = (v) => (Number.isFinite(+v) ? +v : 0);

/* NEDOTČENÝ ŠABLONOVÝ CÍL (průvodce analýzou, 12. 10. 2026).
 *
 * Čerstvá analýza zakládá čtyři předvyplněné cíle (c1–c4) bez částky.
 * `stavCile` je hlásí jako INCOMPLETE — pro cíle stav TEMPLATE_EMPTY nemáme.
 * Průvodce by tak u úplně nové analýzy svítil „Cíle: chybí 4“, což poradce
 * na schůzce nemá jak vysvětlit.
 *
 * Šablona = id z datového modelu (c1–c4), STEJNÝ název a STEJNÝ termín jako
 * v šabloně a žádná částka. Jakmile poradce cokoli z toho změní, je to jeho
 * cíl a chybějící údaj se hlásí. `stavCile` se nemění. */
const SABLONA_CILU = new Map(CILE_SABLONY.map((c) => [c.id, { popis: norm(c.popis), roky: c.roky }]));
const stejnyTermin = (a, b) => {
  if (a === b) return true;
  const x = String(a ?? "").trim();
  const y = String(b ?? "").trim();
  return x !== "" && y !== "" && Number(x) === Number(y);
};

/** Je cíl nedotčená předvyplněná nabídka šablony (c1–c4 bez zásahu poradce)? */
export function jeSablonaCile(c) {
  if (!c || typeof c !== "object" || Array.isArray(c)) return false;
  const vzor = SABLONA_CILU.get(String(c.id ?? ""));
  if (!vzor) return false;
  return norm(c.popis) === vzor.popis && stejnyTermin(c.roky, vzor.roky) && !(num(c.hodnota) > 0);
}
